export default "/_next/static/images/e670e47b4a07eb839ac664558883bcb2.png";